module.exports = __webpack_public_path__ + "img/tab-mine-active.1953ca1d.svg";